import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";

import ReactGA from 'react-ga';

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const GA_TRACKING_ID = isDev ? 'UA-0000000-00' : 'UA-5029867-27';

ReactGA.initialize(GA_TRACKING_ID);
ReactGA.pageview(window.location.pathname+'news');

ReactDOM.render(
    <BrowserRouter basename={"/"}>
        <Route path="/" component={App} />
    </BrowserRouter>,
    document.getElementById("root")
);